import CloseIcon from "@mui/icons-material/Close";
import Launch from "@mui/icons-material/Launch";
import Link from "@mui/joy/Link";
import Sheet from "@mui/joy/Sheet";
import Stack from "@mui/joy/Stack";
import Table from "@mui/joy/Table";
import Typography from "@mui/joy/Typography";
import { DisplayAnswerFacts } from "../../../shared/components/ui/QuestionAnswering/DisplayAnswerFacts";
import { QuestionAnswer } from "../../../models/questionnaire";
import { PersonId } from "../../../models/person";

interface AnswerTableProps {
  readonly questionsAnswers: QuestionAnswer[];
  readonly personIds: PersonId[];
  readonly handleRemove: (index: number) => void;
}

export default function AnswerTable({
  questionsAnswers,
  personIds,
  handleRemove,
}: AnswerTableProps) {
  return (
    <Sheet
      sx={{
        height: "80vh",
        overflow: "auto",
        "--Table-firstColumnWidth": "70px",
        borderRadius: "sm",
      }}
      variant="outlined"
    >
      <Table
        borderAxis="bothBetween"
        hoverRow
        variant="plain"
        sx={{
          tableLayout: "auto",
          "& tr > *:first-child": {
            position: "sticky",
            left: 0,
            bgcolor: "background.surface",
          },
        }}
        stickyHeader
      >
        <thead>
          <tr>
            <th style={{ width: "var(--Table-firstColumnWidth)", zIndex: 99 }}>ID patient</th>
            {questionsAnswers.map((questionAnswer, index) => (
              <th key={`${questionAnswer.text || index}`}>
                <Stack direction="row" spacing={2}>
                  <Typography
                    endDecorator={
                      <CloseIcon
                        onClick={() => handleRemove(index)}
                        fontSize="small"
                        color="action"
                        sx={{ cursor: "pointer" }}
                      />
                    }
                  >
                    {questionAnswer.text}
                  </Typography>
                </Stack>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {personIds.map((personId) => (
            <tr key={personId}>
              <td style={{ zIndex: 50 }}>
                <Link
                  underline="hover"
                  href={"/patient/" + personId}
                  target="_blank"
                  rel="noopener"
                  endDecorator={<Launch fontSize="small" />}
                >
                  {personId.length > 10 ? `${personId.substring(0, 10)}...` : personId}
                </Link>
              </td>
              {questionsAnswers.map((questionAnswer, index) => (
                <td key={`${personId}-${questionAnswer.text || index}`}>
                  <DisplayAnswerFacts
                    answerType={questionAnswer.answer_type || "concept-date"}
                    answers={questionAnswer.answer.filter((a) => a.person_id === personId)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">Totals</th>
            {questionsAnswers.map((questionAnswer, index) => (
              <td key={`total-${questionAnswer.text || index}`}>{questionAnswer.answer?.length}</td>
            ))}
          </tr>
        </tfoot>
      </Table>
    </Sheet>
  );
}
